/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import actions from './actions'
import getters from './getters'
// import modules from './modules'
import mutations from './mutations'
import state from './state'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  // modules,
  mutations,
  state,
  plugins: [
    createPersistedState({
      paths: [
        // Auth & Session
        'token',
        'refreshTokenAdmin',
        'tokenExpDate',
        'refreshTokenExpDate',
        'authStatus',
        'username',
        'fullName',
        'haveDashboard',

        // User & Role
        'dataUser',
        'roleCodeFromLogin',
        'userMenu',
        
        // UI State
        'drawer',
        'titleApp',
        'nextPath',

        // Static/Config (jarang berubah)
        'paramType',
        'status',
        'reportStatusName',
      ]
    })
  ],
})

export default store
